/* Spare product page: option → variant, per-unit price, real stock, honest shipping line. */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function nowInEastern() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());
    const get = (t) => (parts.find((p) => p.type === t) || {}).value;
    return {
      day: get('weekday'), hour: parseInt(get('hour'), 10) % 24, minute: parseInt(get('minute'), 10),
      y: parseInt(get('year'), 10), m: parseInt(get('month'), 10), d: parseInt(get('day'), 10)
    };
  }
  const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function init(root) {
    const dataEl = root.querySelector('[data-spare-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const unit = root.dataset.unit || 'unit';
    const wearDays = parseInt(root.dataset.wearDays || '0', 10);
    const cutoff = parseInt(root.dataset.cutoffHour || '14', 10);
    const showCountdown = root.dataset.showCountdown === 'true';
    const closed = (root.dataset.closed || '').split(/[\s,]+/).filter((x) => /^\d{4}-\d{2}-\d{2}$/.test(x));
    const isShipDay = (dt) => { const wd = dt.getUTCDay(); return wd !== 0 && wd !== 6 && closed.indexOf(dt.toISOString().slice(0, 10)) === -1; };

    const idInput = root.querySelector('[data-spare-variant-input]');
    const fieldsets = root.querySelectorAll('[data-spare-option]');
    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];
    if (!current.available) current = variants.find((v) => v.available && v.price > 0) || variants.find((v) => v.available) || current;
    const selected = current.options.slice();

    const plural = (n) => (n === 1 ? unit : unit + 's');
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const isDamaged = (v) => v.options.some((o) => /damaged/i.test(o));

    function stockHtml(v) {
      if (!v.managed) return '<span class="sp-dot sp-dot--ok"></span><strong>In stock</strong>';
      if (v.qty > 5) return '<span class="sp-dot sp-dot--ok"></span><span><strong>' + v.qty + ' ready to ship</strong></span>';
      if (v.qty > 0) return '<span class="sp-dot sp-dot--low"></span><span><strong>Only ' + v.qty + ' left</strong><span class="sp-muted"> — our real shelf count</span></span>';
      return '<span class="sp-dot sp-dot--out"></span><span><strong>None on the shelf right now.</strong><span class="sp-muted"> We won\'t guess when more arrives.</span></span>';
    }

    function shipText() {
      if (!showCountdown) return 'Ships after inspection';
      const t = nowInEastern();
      const today = new Date(Date.UTC(t.y, t.m - 1, t.d, 12));
      const openToday = isShipDay(today);
      if (openToday && t.hour < cutoff) {
        const mins = (cutoff - t.hour) * 60 - t.minute;
        const h = Math.floor(mins / 60), m = mins % 60;
        return 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> → ships today';
      }
      let next = today, i = 0;
      do { next = new Date(next.getTime() + 864e5); i += 1; } while (!isShipDay(next) && i < 30);
      const when = i === 1 ? 'tomorrow' : (i < 7 ? WEEKDAYS[next.getUTCDay()] : next.toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }));
      return (openToday ? "Today's shipments have left" : "We're closed today") + ' · ships <strong>' + when + '</strong> morning';
    }

    const savIn = root.querySelector('[data-spare-their-price]');
    const savOut = root.querySelector('[data-spare-savings-out]');
    function updateSavings() {
      if (!savIn || !savOut) return;
      const v = current;
      if (!(v.price > 0)) { savOut.innerHTML = "Our price for this option isn't posted yet, so there's nothing to compare."; return; }
      const ours = v.price / v.units; // cents per unit
      const theirs = Math.round(parseFloat(savIn.value) * 100);
      if (!(theirs > 0)) { savOut.innerHTML = '<span>Ours: <strong>' + money(Math.round(ours)) + '</strong> per ' + unit + '. Enter what you pay to compare.</span>'; return; }
      const diff = theirs - ours;
      if (diff < 1) {
        savOut.innerHTML = "<span>You're already paying " + (diff <= -1 ? 'less than' : 'about the same as') + ' our <strong>' + money(Math.round(ours)) + '</strong> per ' + unit + '. Keep your current source.</span>';
        return;
      }
      let html = "<span>You'd save <strong>" + money(Math.round(diff)) + ' per ' + unit + '</strong> (' + Math.round((diff / theirs) * 100) + '% less).</span>';
      if (wearDays > 0) {
        const perYear = Math.ceil(365 / wearDays);
        html += '<span class="sp-save__year">About <strong>' + money(Math.round(diff * perYear)) + '</strong> a year</span>' +
          '<span class="sp-save__fine">' + perYear + ' ' + plural(perYear) + ' a year at ' + wearDays + ' days each, before shipping and tax.</span>';
      }
      savOut.innerHTML = html;
    }
    if (savIn) savIn.addEventListener('input', updateSavings);
    root.querySelectorAll('[data-spare-ref]').forEach((chip) => {
      chip.addEventListener('click', () => { savIn.value = parseFloat(chip.dataset.spareRef).toFixed(2); updateSavings(); savIn.focus(); });
    });

    function render() {
      const v = findVariant(selected) || current;
      current = v;
      idInput.value = v.id;

      root.querySelectorAll('[data-spare-price]').forEach((el) => { el.textContent = v.price > 0 ? money(v.price) : 'Price TBD'; });
      const per = root.querySelector('[data-spare-per]');
      if (per) {
        const bits = [];
        if (v.price > 0 && v.units > 1) bits.push(money(Math.round(v.price / v.units)) + ' per ' + unit);
        if (v.price > 0 && wearDays > 0) bits.push(money(Math.round(v.price / (v.units * wearDays))) + ' a day');
        per.textContent = bits.join(' · ');
      }

      const save = root.querySelector('[data-spare-save]');
      if (save) {
        save.textContent = '';
        if (isDamaged(v) && v.price > 0) {
          const ci = v.options.findIndex((o) => /damaged/i.test(o));
          const sealed = variants.find((s) => s.options.every((o, i) => (i === ci ? !/damaged/i.test(o) : o === v.options[i])));
          if (sealed && sealed.price > v.price) save.textContent = money(sealed.price - v.price) + ' less than a perfect box';
        }
      }

      const days = root.querySelector('[data-spare-days]');
      if (days) days.textContent = wearDays ? 'About ' + v.units * wearDays + ' days of wear (' + v.units + ' ' + plural(v.units) + ' × ' + wearDays + ' days).' : '';

      const stock = root.querySelector('[data-spare-stock]');
      if (stock) stock.innerHTML = stockHtml(v);
      updateSavings();
      const ship = root.querySelector('[data-spare-ship]');
      if (ship) ship.innerHTML = !v.available ? 'Not shipping until it\'s back on the shelf' : (v.price > 0 ? shipText() : 'Ships once pricing is posted');

      const badge = root.querySelector('[data-spare-cond-badge]');
      if (badge) {
        const dmg = isDamaged(v);
        badge.textContent = dmg ? 'DAMAGED BOX · SEALED INSIDE' : 'FACTORY SEALED';
        badge.className = 'sp-pill ' + (dmg ? 'sp-pill--apricot' : 'sp-pill--mint');
      }
      const note = root.querySelector('[data-spare-damaged-note]');
      if (note) note.hidden = !isDamaged(v);

      const add = root.querySelector('[data-spare-add]');
      const stickyBtn = root.querySelector('[data-spare-sticky-btn]');
      const buyable = v.available && v.price > 0;
      const label = !v.available ? 'None left' : (v.price > 0 ? 'Add to cart' : 'Price coming soon');
      [add, stickyBtn].forEach((b) => { if (b) { b.disabled = !buyable; b.textContent = label; } });
      root.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach((pay) => { pay.style.display = buyable ? '' : 'none'; });
      const stickySub = root.querySelector('[data-spare-sticky-sub]');
      if (stickySub) stickySub.textContent = v.title.replace('Default Title', '') + (v.price > 0 ? ' · ' + money(v.price) : '');

      // Per-option hints and availability
      fieldsets.forEach((fs) => {
        const idx = parseInt(fs.dataset.spareOption, 10);
        fs.querySelectorAll('.sp-opt__btn').forEach((label) => {
          const input = label.querySelector('input');
          const trial = selected.slice(); trial[idx] = input.value;
          const tv = findVariant(trial);
          const anyAvail = variants.some((x) => x.options[idx] === input.value && x.available);
          input.disabled = !anyAvail;
          label.classList.toggle('is-disabled', !anyAvail);
          label.classList.toggle('is-unavailable', !anyAvail);
          input.checked = selected[idx] === input.value;
          const hint = label.querySelector('[data-spare-hint]');
          if (hint && !/condition/i.test(fs.querySelector('legend').textContent)) {
            const span = tv && wearDays ? '~' + tv.units * wearDays + ' days\n' : '';
            if (tv && tv.available && tv.price > 0) hint.textContent = span + money(Math.round(tv.price / tv.units)) + ' each';
            else if (tv && tv.available) hint.textContent = 'Price coming soon';
            else if (anyAvail) hint.textContent = 'Other condition only';
            else hint.textContent = '';
          }
        });
      });

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach((fs) => {
      const idx = parseInt(fs.dataset.spareOption, 10);
      fs.addEventListener('change', (e) => {
        if (!e.target || e.target.type !== 'radio') return;
        const trial = selected.slice(); trial[idx] = e.target.value;
        const exact = findVariant(trial);
        if (exact && exact.available) { selected[idx] = e.target.value; }
        else {
          // Keep the tapped choice and move the other options to the closest combination that is on the shelf.
          const fallback = variants.find((x) => x.options[idx] === e.target.value && x.available);
          if (fallback) fallback.options.forEach((o, i) => { selected[i] = o; });
          else selected[idx] = e.target.value;
        }
        render();
      });
    });

    // Photo thumbs
    const main = root.querySelector('[data-spare-main]');
    root.querySelectorAll('[data-spare-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-spare-thumb]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        const img = main.querySelector('img');
        const label = main.querySelector('[data-spare-main-label]');
        if (btn.dataset.src && img) { img.src = btn.dataset.src; img.removeAttribute('srcset'); }
        if (btn.dataset.label && label) label.textContent = btn.dataset.label;
      });
    });

    // Sticky buy bar once the main buttons scroll away
    const sticky = root.querySelector('[data-spare-sticky]');
    const buy = root.querySelector('.sp-buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const hiddenAbove = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', hiddenAbove);
        sticky.setAttribute('aria-hidden', hiddenAbove ? 'false' : 'true');
        const b = sticky.querySelector('button');
        if (b) b.tabIndex = hiddenAbove ? 0 : -1;
      }).observe(buy);
    }

    render();
    setInterval(() => {
      const ship = root.querySelector('[data-spare-ship]');
      if (ship && current.available && current.price > 0) ship.innerHTML = shipText();
    }, 30000);
  }

  function boot() { document.querySelectorAll('[data-spare-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
